/* eslint-disable no-shadow */
import { STRINGS } from 'config';

export const initialState = {
  validationErrors: [],
  validationMessages: [],
  isCancelProgressModalOpen: false,
};

export const sessionReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case STRINGS.SESSION_REDUCER.SET_SESSION_EXPIRY_VALIDATION:
      return { ...state, validationErrors: [{ localError: action.payload, reference: 'SessionTimedOutValidation' }] };
    case 'session/CLEAR_SESSION_VALIDATION':
      return { ...state, validationErrors: [] };
    case STRINGS.SESSION_REDUCER.SET_CONNECTIVITY_MESSAGE:
      return { ...state, validationMessages: [{ message: action.payload, reference: 'ReconnectedToInternet' }] };
    case STRINGS.SESSION_REDUCER.CLEAR_VALIDATION_MESSAGE:
      return { ...state, validationMessages: [] };
    case STRINGS.SESSION_REDUCER.CANCEL_PROGRESS:
      return { ...state, isCancelProgressModalOpen: true };
    case STRINGS.SESSION_REDUCER.CLOSE_CANCEL_PROGRESS_WARNING: {
      return { ...state, isCancelProgressModalOpen: false };
    }
    default:
      return state;
  }
};
